import {
	AspectRatioContainer,
	Container,
	CTA,
	Image,
	Richtext,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { useTrackingManager } from '../../../tracking/useTrackingManager';
import { PortalContext } from '../../../context/PortalContext';
import { formatOwnership } from '../../../tracking/trackingHelper';
import { actionRedirect } from '../../../helpers/common-helpers';
import { COLOR_TOKEN, isNewBrandDesign } from '../../../helpers/color-tokens';
import { NovedadesItem } from '../novedades-type';

interface NovedadesCardProps {
	novedades: NovedadesItem;
}

const CardContainer = styled.div`
	background: ${COLOR_TOKEN.background.card.primary};
	border-radius: 16px;
	height: 100%;
	padding: 24px;
	backdrop-filter: blur(10px);

	/* Shadow02 */
	box-shadow: ${isNewBrandDesign()
		? 'none'
		: '0px 2px 4px 0px rgba(0, 14, 38, 0.2), 0px 3px 15px 0px rgba(0, 14, 38, 0.1)'};

	/* Mobile & Tablet */
	@media (max-width: 959px) {
		padding-top: var(--size-dynamic0150);
		padding-bottom: var(--size-dynamic0150);
		padding-right: var(--size-dynamic0200);
		padding-left: var(--size-dynamic0200);
	}
`;

const NovedadesCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: var(--size-dynamic0050);
`;

// text container ocupa todo el espacio del medio para poder
// alinear el cta en el margen inferior izquierdo
const NovedadesTextContainer = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

const NovedadesImage = styled(Image)`
	border-radius: 16px;
`;

export const NovedadesCard = ({ novedades }: NovedadesCardProps) => {
	const trackingManager = useTrackingManager();

	const { portalService, userInteractionService } = useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();

	const handleOnClick = (novedadesItem: NovedadesItem) => {
		if (novedadesItem.cta.src) {
			trackingManager.trackClubVWButtonClick(
				'Novedades',
				{ contentId: `${novedadesItem.title}` },
				{ vehicle: formatOwnership(userVehicles?.vehicles) },
			);

			if (novedadesItem.cta.src.includes('action:')) {
				actionRedirect(userInteractionService, novedadesItem.cta.src);
			} else {
				window.open(novedadesItem.cta.src, '_blank');
			}
		}
	};

	return (
		<CardContainer data-testid="novedades-card">
			<NovedadesCardContainer>
				<AspectRatioContainer ratio="16:9">
					<NovedadesImage src={novedades.imageUrl} alt={novedades.title} />
				</AspectRatioContainer>
				<NovedadesTextContainer>
					<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.left} bold>
						{novedades.title}
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.left}>
						<Richtext markdown={novedades.description} />
					</Text>
				</NovedadesTextContainer>
				{novedades.cta.src && (
					<Container horizontalAlign="flex-start">
						<CTA tag="button" emphasis="nbab" onClick={() => handleOnClick(novedades)}>
							Descubre más
						</CTA>
					</Container>
				)}
			</NovedadesCardContainer>
		</CardContainer>
	);
};
